<template>
	<div class="form-body">
		<b-breadcrumb :items="items"></b-breadcrumb>
		<b-card>
			<h3>
				<span>{{ $t('lang.content.user') }}</span>
			</h3>
			<b-form>
				<b-row>
					<b-col md="6">
						<b-form-group
							:label="$t('lang.content.name')"
							label-for="txtfirstName"
						>
							<b-form-input
								id="txtfirstName"
								v-model.trim="user.firstName"
								type="text"
								:placeholder="$t('lang.content.name')"
								class="style2"
								disabled
							></b-form-input>
						</b-form-group>
					</b-col>

					<b-col md="6">
						<b-form-group
							id="input-group-2"
							:label="$t('lang.content.lastname')"
							label-for="txtlastName"
						>
							<b-form-input
								id="lastName"
								v-model.trim="user.lastName"
								type="text"
								:placeholder="$t('lang.content.lastname')"
								class="style2"
								disabled
							></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>

				<b-row>
					<b-col md="12">
						<b-form-group
							id="input-group-3"
							:label="$t('lang.content.email')"
							label-for="txtEmail"
						>
							<b-form-input
								id="txtEmail"
								v-model.trim="user.email"
								:placeholder="$t('lang.content.email')"
								class="style2"
								disabled
							></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>

				<div
					class="
						d-flex
						flex-wrap
						justify-content-lg-end
						align-items-center
						btn-wrap
						pt-lg-5 pt-md-4 pt-2
					"
				>
					<b-button type="button" to="/usuarios">{{
						$t('lang.buttons.back')
					}}</b-button>
				</div>
			</b-form>
		</b-card>
	</div>
</template>

<script>
import UsersService from '@/services/UsersService';

export default {
	name: 'viewUser',
	data: () => ({
		items: [],
		id: '',
		user: {
			firstName: '',
			lastName: '',
			email: '',
			id: ''
		}
	}),
	/*validations: {
    user: {
      firstName: { required, minLength: minLength(3) },
      lastName: { required, minLength: minLength(4) },
      email: { required, email },
    },
  },*/
	mounted() {
		this.getUsers();
		this.items = [
			{
				text: this.$t('lang.breadcrumd.users'),
				href: '/usuarios'
			},
			{
				text: this.$t('lang.breadcrumd.view_user'),
				active: true
			}
		];
	},

	methods: {
		getUsers() {
			UsersService.show(this.$route.params.id).then((response) => {
				if (response.Code == 200) this.user = response.Data;
			});
		}
		/*save() {
      this.submitted = true;

      this.$v.user.$touch();
      this.user.id = this.user._id;
      
      if (!this.$v.user.$error) {
        UsersService.edit(this.user).then((response) => {
        
          let timerInterval;
          if (response.Code == 200) {
            this.$swal.fire({
              icon: "success",
              title: "¡Genial!",
              text: response.Message,
              allowOutsideClick: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                this.$swal.showLoading();
                timerInterval = setInterval(() => {
                  const content = this.$swal.getContent();
                  if (content) {
                    const b = content.querySelector("b");
                    if (b) {
                      b.textContent = this.$swal.getTimerLeft();
                    }
                  }
                }, 100);
              },
              willClose: () => {
                window.location.replace("/usuarios");
                clearInterval(timerInterval);
              },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "¡Error!",
              text: response.Message,
              confirmButtonText: "Aceptar",
            });
          }

          this.$v.user.$reset();
        });
      }
    },*/
	}
};
</script>
